// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 3,
        parentComponent: true,
        controllerName: 'InitiativeCall',
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        actions: {
            listAction: "/api/Initiative/GetInitiativeDetail/",
            deleteAction: "/api/Initiative",
            updateAction: "/api/Initiative",
            createAction: "/api/Initiative"
        },
        fields: {
            InitiativeId: {
                primaryKey: true,
            },
            Name: {
                title: "Name",
                type: "TextInput",
                required: true,
                languageManager: true,
                tableName: "Initiative",
                redirect: {
                    menuId: 35,
                    action: '/Admin/Program/Initiative/InitiativeForm'
                }
            },
            ProgramId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                title: "Program"
            },
            DonorId: {
                title: "Donor",
                required: true,
                type: "ComboBox",
                autocomplete: true,
            },
            RegionId: {
                required: true,
                type: "MultiSelect",
                chips: true,
                title: "Region"
            },
            BudgetId: {
                title: "Initiative Budget",
                required: true,
                type: "ComboBox",
                autocomplete: true,
            },
            BudgetCurrencyId: {
                title: "Budget Currency",
                required: true,
                type: "ComboBox",
                autocomplete: true,
            },
            BudgetExact: {
                title: "Exact Budget",
                type: "Number",
                currency: {
                    enabled: true,
                    precision: 2
                }
            },
            BudgetExactCurrencyId: {
                title: "Exact Budget Currency",
                type: "ComboBox",
                autocomplete: true,
                list: false,
            },
            MatchFunding: {
                title: "Match Funding (%)",
                required: true,
                type: "Number",
                list: false,
            },
            DurationId: {
                title: "Initiative Duration (Years)",
                required: true,
                type: "ComboBox",
                autocomplete: true,
            },
            // ExactDuration: {
            //     title: "Exact Duration",
            //     type: "Number",
            //     list: false,
            // },
            ExactStartDate: {
                title: "Exact Start Date",
                type: "Date",
                list: false,
            },
            ExactEndDate: {
                title: "Exact End Date",
                type: "Date",
                list: false,
            },
            PolicyId: {
                title: "Policy",
                required: true,
                type: "MultiSelect",
                chips: true,
                list: false,
            },
            ReportingFreqId: {
                title: "Reporting Frequency (Grantees)",
                required: true,
                type: "ComboBox",
                autocomplete: true,
                list: false,
            },
            ImpactMeasuringFreqId: {
                title: "Reporting Frequency (IUCN)",
                required: true,
                type: "ComboBox",
                autocomplete: true,
                list: false,
            },
            Active: {
                required: true,
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Active"
            },
            RequireAudit: {
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Require Audit"
            },
            DocumentStoreId: {
                type: "Hidden"
            },
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) { },

        //#. fn_formCancel function
        formCancel(state, payload) { },

        //#. fn_recordCreated function
        recordCreated(state, payload) { },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) { },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) { },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) { },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) { }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        }
    }
}